import React, {FC, ReactNode} from 'react';
import {View} from 'react-native';

import Icon, {IIconProps} from '@/components/Icon';
import Text, {TextProps} from '@/components/Text/Text';
import Touchable from '@/components/Touchable/Touchable';
import {useThemedStyles} from '@/theme';

import {styles} from './MenuItem.style';

export const MenuItem: FC<{
  onPress: () => void;
  icon?: IIconProps;
  iconComponent?: ReactNode;
  isActive?: boolean;
  disabled?: boolean;
  text?: string;
  textId?: string;
  textProps?: TextProps;
  suffixComponent?: ReactNode;
}> = ({
  onPress,
  icon,
  iconComponent,
  isActive = false,
  disabled = false,
  text,
  textId,
  textProps,
  suffixComponent,
}) => {
  const style = useThemedStyles(styles);

  return (
    <Touchable
      style={[
        style.firstLevelItem,
        style.item,
        disabled && style.item_disabled,
        isActive && style.item_active,
      ]}
      disabled={disabled}
      hoveredStyle={style.item_hover}
      pressedStyle={style.item_pressed}
      onPress={onPress}>
      <View style={style.firstLevelItemIcon}>
        {iconComponent ? iconComponent : icon ? <Icon {...icon} /> : null}
      </View>
      <Text id={textId} numberOfLines={1} weight="semibold" flex {...textProps}>
        {text}
      </Text>

      {suffixComponent}
    </Touchable>
  );
};
